// Outputs the scrollEnd event when the scroll value of the element reaches 80% of the total height
//
// Example:
// <div class="result-container" infiniteScroll (scrollEnd)="functionFromYourComponent()"></div>
//

import { Output, Directive, ElementRef, HostListener, EventEmitter } from '@angular/core';

@Directive({ selector: '[infiniteScroll]' })
export class InfiniteScrollDirective {
  @Output() readonly scrollEnd: EventEmitter<any> = new EventEmitter();

  constructor(private el: ElementRef) {}

  @HostListener('scroll', ['$event'])
  private onWindowScroll(): void {
    const maxHeight = (this.el.nativeElement.scrollHeight - this.el.nativeElement.clientHeight) * 0.8;

    if (this.el.nativeElement.scrollTop >= maxHeight) {
      this.scrollEnd.emit();
    }
  }
}
